<div class="accordion py-4">
  <ng-content />
</div>
